"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IaCountUtil = void 0;
const A_1 = require("../A");
const IAValidator_1 = require("../ia/IAValidator");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const RolEchainCalculatorFactory_1 = require("../rolEchain/RolEchainCalculatorFactory");
class IaCountUtil {
    /**
     * Calculates the number of IA elements required for a given Kette domain object.
     */
    static getCountForKette(ia, ketteModel, logger) {
        var _a;
        if (ia.manualCount) {
            return ia.manualCount;
        }
        if ((0, echain_shared_articles_1.isRolEchainUnionUnsafe)(ketteModel)) {
            return this.getCountForRolEchain(ia, ketteModel);
        }
        const kette = (0, A_1.A)(ketteModel);
        if (IAValidator_1.IAValidator.validateCountForKette(ia, kette).hasIssues())
            return undefined;
        if (kette.halbstegig) {
            return this.getCountForHalbstegigeKette(ia, kette, logger);
        }
        // TODO: EKE-12701 make use of switch case !!
        if (kette.isSerieESkin()) {
            return this.getCountForESkinKette(ia, kette, logger);
        }
        return IaCountUtil.getSimpleCountForNumGlieder(ia, (_a = kette.numGlieder) !== null && _a !== void 0 ? _a : 0);
    }
    static getCountForHalbstegigeKette(ia, kette, logger) {
        if (ia.manualCount) {
            return ia.manualCount;
        }
        if (!ia.startingAtNthKettenglied || !ia.perNthKettenglied) {
            return undefined;
        }
        const offsetKettenglieder = ia.startingAtNthKettenglied - 1;
        const kettengliederRest = Math.max(0, kette.numGlieder - offsetKettenglieder);
        const ketteModel = kette.toModel();
        const kettenSystem = (0, echain_shared_articles_1.findKettenSystemGroup)(ketteModel);
        if (kettenSystem === echain_shared_articles_1.KettenSystemGroup.HALBSTEGIG_E4_1_OR_E4_00 ||
            kettenSystem === echain_shared_articles_1.KettenSystemGroup.HALBSTEGIG_E61_OR_E6 ||
            kettenSystem === echain_shared_articles_1.KettenSystemGroup.HALBSTEGIG_E4_4_OR_E4_light) {
            return Math.ceil(kettengliederRest / ia.perNthKettenglied);
        }
        if (logger) {
            logger.warn(`${this.className}.getCountForHalbstegigeKette: Couldn't calculate because the Kettensystem is unknown.`);
        }
        return undefined;
    }
    static getCountForESkinKette(ia, kette, logger) {
        if (ia.manualCount) {
            return ia.manualCount;
        }
        // We require numGlieder to be given for calculation. If it's not set we return undefined.
        if (!kette.numGlieder) {
            if (logger) {
                logger.warn(`${this.className}.getCountForESkinKette: Couldn't calculate because numGlieder is unknown.`);
            }
            return undefined;
        }
        const offsetFestpunktAndMitnehmer = 1;
        // If any of the both props is invalid, we throw because
        // we assume that the configuration has be done (we have numGlieder)
        // but the startingAtNthKettenglied and perNthKettenglied are not properly set
        if (ia.startingAtNthKettenglied !== 1 + offsetFestpunktAndMitnehmer) {
            throw new Error(`${this.className}.getCountForESkinKette: Invalid startingAtNthKettenglied = ${ia.startingAtNthKettenglied}`);
        }
        if (ia.perNthKettenglied !== 1) {
            throw new Error(`${this.className}.getCountForESkinKette: Invalid perNthKettenglied = ${ia.perNthKettenglied}`);
        }
        const numGliederWhereIACanBeAssembled = kette.numGlieder - (ia.startingAtNthKettenglied - 1) - offsetFestpunktAndMitnehmer;
        return Math.max(0, Math.ceil(numGliederWhereIACanBeAssembled / ia.perNthKettenglied));
    }
    /**
     * Calculates the number of IA elements required for a given RolEchain
     */
    static getCountForRolEchain(ia, rolEchain) {
        var _a;
        if (ia.manualCount) {
            return ia.manualCount;
        }
        if (!(0, echain_shared_articles_1.isCalculateableRolEchain)(rolEchain)) {
            throw new Error(`${this.className}.getCountForRolEchain(): rolEchain not calculatable`);
        }
        if (IAValidator_1.IAValidator.validateCountForRolEchain(ia, rolEchain).hasIssues())
            return undefined;
        const calculator = RolEchainCalculatorFactory_1.RolEchainCalculatorFactory.getCalculator(rolEchain);
        const totalNumLinks = calculator.calcTotalNumLinks(rolEchain);
        const rolLinkNumOeffnungsstege = (_a = rolEchain.Serie.NumOeffnungsstege) !== null && _a !== void 0 ? _a : 1;
        // in respect to EKE-11507, we need to calculate a "virtual link count" for some rol-echains
        let virtualTotalLinks = totalNumLinks;
        if (rolLinkNumOeffnungsstege > 1) {
            const rolLinks = calculator.calcNumLinksByType(rolEchain).numRolLinks;
            // substract already included rolLink count
            virtualTotalLinks -= rolLinks;
            // adjust virtual count by multiplying the rolLinks oeffnungsstege
            virtualTotalLinks += rolLinks * rolLinkNumOeffnungsstege;
        }
        return IaCountUtil.getSimpleCountForNumGlieder(ia, virtualTotalLinks);
    }
    /**
     * Retrieves number of IAs on base of a simple calculation without any special rules.
     */
    static getSimpleCountForNumGlieder(ia, numGlieder) {
        if (ia.startingAtNthKettenglied && ia.perNthKettenglied) {
            const offsetLinks = ia.startingAtNthKettenglied - 1;
            const linksRemaining = Math.max(0, numGlieder - offsetLinks);
            return Math.max(0, Math.ceil(linksRemaining / ia.perNthKettenglied));
        }
        return undefined;
    }
}
exports.IaCountUtil = IaCountUtil;
IaCountUtil.className = 'IaCountUtil';
//# sourceMappingURL=IaCountUtil.js.map